module.exports = __webpack_public_path__ + "img/bin.b2e73bb1.svg";